import { GetContactAttributeActivityResponse } from '../../types/activity/activity.types';
import {
  GET_CONTACT_ATTRIBUTE_ACTIVITY_REQUEST,
  GET_CONTACT_ATTRIBUTE_ACTIVITY_SUCCESS,
  GET_CONTACT_ATTRIBUTE_ACTIVITY_FAILURE,
  GetContactAttributeActivityRequestAction,
  GetContactAttributeActivitySuccessAction,
  GetContactAttributeActivityFailureAction,
} from './activity.types';

// Get Contact Attribute Activity Actions
export const getContactAttributeActivityRequest = (
  contactId: string,
  page: number,
  limit: number
): GetContactAttributeActivityRequestAction => ({
  type: GET_CONTACT_ATTRIBUTE_ACTIVITY_REQUEST,
  payload: { contactId, page, limit },
});

export const getContactAttributeActivitySuccess = (
  response: GetContactAttributeActivityResponse
): GetContactAttributeActivitySuccessAction => ({
  type: GET_CONTACT_ATTRIBUTE_ACTIVITY_SUCCESS,
  payload: response,
});

export const getContactAttributeActivityFailure = (
  error: string
): GetContactAttributeActivityFailureAction => ({
  type: GET_CONTACT_ATTRIBUTE_ACTIVITY_FAILURE,
  payload: error,
});
